import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
var render = function render() {
  var _vm$sheetsToImport;
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    attrs: {
      persistent: "",
      "max-width": !_vm.isConfiguring ? "100%" : 950
    },
    model: {
      value: _vm.shown,
      callback: function callback($$v) {
        _vm.shown = $$v;
      },
      expression: "shown"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    on: {
      click: function click($event) {
        return _vm.cancel();
      }
    }
  })], 1), _c(VCardTitle, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v("Import supplier prices")])]), _c(VCardText, [_vm.isConfiguring ? [_c("div", {
    staticClass: "one"
  }, [_c("SupplierSelectComponent", {
    ref: "supplierSelect",
    attrs: {
      suppliers: _vm.suppliers,
      selected: _vm.supplierId,
      required: true,
      disabled: _vm.isAnyActionInProgress
    },
    on: {
      changeSupplier: _vm.changeSupplier,
      fetchSuppliers: _vm.fetchSuppliersWhenItemsUpdated
    }
  }), _vm._l(_vm.getSelectedSupplierImportSettingsSheets, function (sheet, index) {
    return _vm.selectedSupplierhasPreparationActions ? _c("div", {
      staticClass: "my-2"
    }, [_c("p", {
      staticClass: "my-1"
    }, [_vm._v(" Actions to prepare sheet" + _vm._s(_vm.getSelectedSupplierImportSettingsSheets.length > 1 ? "s" : "") + " to be properly imported : ")]), sheet.preparationActions ? _c("p", [_vm._v(" Sheet " + _vm._s(index + 1) + " : "), _c("span", {
      staticClass: "bold"
    }, [_vm._v(_vm._s(sheet.preparationActions))])]) : _vm._e()]) : _vm._e();
  }), _vm.supplierId ? _c("div", {
    staticClass: "mt-4"
  }, [_c("UploaderPrices", {
    key: _vm.supplierId,
    ref: "uploader_supplierprices",
    staticClass: "w100p",
    attrs: {
      url: _vm.uploadUrl,
      fileTypes: [".xls", ".xlsx", ".xlsm"],
      multiple: false,
      hideUploadButton: ""
    },
    on: {
      sync: _vm.syncFiles,
      "click:upload": _vm.acknowledgeUpload,
      "upload:failed": _vm.uploadFailed
    }
  })], 1) : _vm._e(), _vm.hasValidFile ? _c("div", _vm._l(_vm.sheetsToImport, function (sheetToImport, index) {
    var _sheetToImport$form$t;
    return _c("div", {
      key: "sheetToImport-" + index,
      staticClass: "sheetToImport"
    }, [_c("div", {
      staticClass: "flex justify-between items-center"
    }, [_c("div", [_vm._v(" Sheet : "), _c("span", {
      staticClass: "text-bigger text-bold"
    }, [_vm._v(_vm._s(sheetToImport.sheetName))])]), _c(VCheckbox, {
      staticClass: "mt-0",
      staticStyle: {
        width: "fit-content"
      },
      attrs: {
        disabled: _vm.isImporting,
        label: sheetToImport.form.isActive ? "Will be imported" : "Will NOT be imported",
        "hide-details": "auto"
      },
      model: {
        value: sheetToImport.form.isActive,
        callback: function callback($$v) {
          _vm.$set(sheetToImport.form, "isActive", $$v);
        },
        expression: "sheetToImport.form.isActive"
      }
    })], 1), sheetToImport.form.isActive ? _c(VForm, {
      ref: "form",
      refInFor: true,
      staticClass: "dfwa-form",
      model: {
        value: sheetToImport.form.valid,
        callback: function callback($$v) {
          _vm.$set(sheetToImport.form, "valid", $$v);
        },
        expression: "sheetToImport.form.valid"
      }
    }, [_c(VCheckbox, {
      staticClass: "mt-0",
      attrs: {
        disabled: _vm.isAnyActionInProgress,
        label: sheetToImport.form.isAutoDuplicateMissingVintageOrBottling ? "Will create a clone of an other existing vintage/bottling if match" : "Will NOT create a clone of an other existing vintage/bottling if match",
        "hide-details": "auto"
      },
      model: {
        value: sheetToImport.form.isAutoDuplicateMissingVintageOrBottling,
        callback: function callback($$v) {
          _vm.$set(sheetToImport.form, "isAutoDuplicateMissingVintageOrBottling", $$v);
        },
        expression: "sheetToImport.form.isAutoDuplicateMissingVintageOrBottling"
      }
    }), _c(VTextarea, {
      attrs: {
        label: "Actions to prepare sheet to be properly imported (ex: keep only some wineries)",
        rows: "1",
        "auto-grow": "",
        "hide-details": "auto"
      },
      model: {
        value: sheetToImport.form.preparationActions,
        callback: function callback($$v) {
          _vm.$set(sheetToImport.form, "preparationActions", $$v);
        },
        expression: "sheetToImport.form.preparationActions"
      }
    }), _c(VAutocomplete, {
      staticClass: "required",
      attrs: {
        label: "Row for title of columns",
        disabled: _vm.isAnyActionInProgress,
        items: sheetToImport.rows,
        "item-text": "name",
        "item-value": "id",
        "hide-details": "auto",
        rules: [_vm.rules.mustSelectValueZeroOk]
      },
      on: {
        change: function change($event) {
          return _vm.selectRowTitle(sheetToImport);
        }
      },
      model: {
        value: sheetToImport.form.rowTitle,
        callback: function callback($$v) {
          _vm.$set(sheetToImport.form, "rowTitle", $$v);
        },
        expression: "sheetToImport.form.rowTitle"
      }
    }), sheetToImport.columns.length ? _c("div", [_c("div", {
      staticClass: "column-chooser"
    }, [_c("div", [_c("div", {
      staticClass: "subtitle"
    }, [_vm._v("Price / b")]), _c(VAutocomplete, {
      staticClass: "required",
      attrs: {
        label: "Column",
        disabled: _vm.isAnyActionInProgress,
        items: sheetToImport.columns,
        "item-text": "name",
        "item-value": "id",
        rules: [_vm.rules.mustSelectValue],
        "hide-details": "auto"
      },
      model: {
        value: sheetToImport.form.price.columnName,
        callback: function callback($$v) {
          _vm.$set(sheetToImport.form.price, "columnName", $$v);
        },
        expression: "sheetToImport.form.price.columnName"
      }
    })], 1), _c("div", [_c("div", {
      staticClass: "subtitle"
    }, [_vm._v("Bottling")]), _c(VAutocomplete, {
      staticClass: "required",
      attrs: {
        label: "Column",
        disabled: _vm.isAnyActionInProgress,
        items: sheetToImport.columns,
        "item-text": "name",
        "item-value": "id",
        rules: [_vm.rules.mustSelectValue],
        "hide-details": "auto"
      },
      model: {
        value: sheetToImport.form.bottling.columnName,
        callback: function callback($$v) {
          _vm.$set(sheetToImport.form.bottling, "columnName", $$v);
        },
        expression: "sheetToImport.form.bottling.columnName"
      }
    }), _c(VAutocomplete, {
      staticClass: "required",
      attrs: {
        label: "Unit",
        disabled: _vm.isAnyActionInProgress,
        items: _vm.supplierPriceVolumeUnits,
        "item-text": "text",
        "item-value": "id",
        rules: [_vm.rules.mustSelectValue],
        "hide-details": "auto"
      },
      model: {
        value: sheetToImport.form.bottling.unit,
        callback: function callback($$v) {
          _vm.$set(sheetToImport.form.bottling, "unit", $$v);
        },
        expression: "sheetToImport.form.bottling.unit"
      }
    })], 1), _c("div", [_c("div", {
      staticClass: "subtitle"
    }, [_vm._v("Vintage")]), _c(VAutocomplete, {
      attrs: {
        label: "Column",
        clearable: "",
        disabled: _vm.isAnyActionInProgress,
        items: sheetToImport.columns,
        "item-text": "name",
        "item-value": "id",
        "hide-details": "auto"
      },
      model: {
        value: sheetToImport.form.vintage.columnName,
        callback: function callback($$v) {
          _vm.$set(sheetToImport.form.vintage, "columnName", $$v);
        },
        expression: "sheetToImport.form.vintage.columnName"
      }
    })], 1), _c("div", [_c("div", {
      staticClass: "subtitle"
    }, [_vm._v("Type/Color")]), _c(VAutocomplete, {
      attrs: {
        label: "Column",
        clearable: "",
        disabled: _vm.isAnyActionInProgress,
        items: sheetToImport.columns,
        "item-text": "name",
        "item-value": "id",
        "hide-details": "auto"
      },
      model: {
        value: sheetToImport.form.type.columnName,
        callback: function callback($$v) {
          _vm.$set(sheetToImport.form.type, "columnName", $$v);
        },
        expression: "sheetToImport.form.type.columnName"
      }
    }), ((_sheetToImport$form$t = sheetToImport.form.type.columnName) === null || _sheetToImport$form$t === void 0 ? void 0 : _sheetToImport$form$t.length) > 0 ? _c(VAutocomplete, {
      staticClass: "required",
      attrs: {
        label: "Unit",
        disabled: _vm.isAnyActionInProgress,
        items: _vm.supplierPriceTypeVersions,
        "item-text": "text",
        "item-value": "id",
        rules: [_vm.rules.mustSelectValue],
        "hide-details": "auto"
      },
      model: {
        value: sheetToImport.form.type.unit,
        callback: function callback($$v) {
          _vm.$set(sheetToImport.form.type, "unit", $$v);
        },
        expression: "sheetToImport.form.type.unit"
      }
    }) : _vm._e()], 1)]), _c("div", {
      staticClass: "column-chooser"
    }, [_c("div", [_c("div", {
      staticClass: "subtitle"
    }, [_vm._v("Quantity Available")]), _c(VAutocomplete, {
      attrs: {
        label: "Column",
        disabled: _vm.isAnyActionInProgress,
        items: sheetToImport.columns,
        "item-text": "name",
        "item-value": "id",
        clearable: "",
        rules: [],
        "hide-details": "auto"
      },
      model: {
        value: sheetToImport.form.quantity.columnName,
        callback: function callback($$v) {
          _vm.$set(sheetToImport.form.quantity, "columnName", $$v);
        },
        expression: "sheetToImport.form.quantity.columnName"
      }
    }), _c(VTextField, {
      staticClass: "required",
      attrs: {
        label: "Quantity default",
        disabled: _vm.isAnyActionInProgress,
        rules: [_vm.rules.mustBeGreaterThan0],
        "hide-details": "auto"
      },
      on: {
        keypress: _vm.filterIntegerKey
      },
      model: {
        value: sheetToImport.form.quantityDefault,
        callback: function callback($$v) {
          _vm.$set(sheetToImport.form, "quantityDefault", $$v);
        },
        expression: "sheetToImport.form.quantityDefault"
      }
    })], 1)]), _c("div", {
      staticClass: "column-chooser --version-2"
    }, [_c("div", [_c("div", {
      staticClass: "subtitle"
    }, [_vm._v("Searchable label composition")]), _c("div", {
      staticClass: "flex flex-column gap-4"
    }, _vm._l(sheetToImport.form.names, function (n, i) {
      return _c("div", {
        key: "labelCompo" + i,
        staticClass: "flex w100p"
      }, [_c("div", {
        staticClass: "flex-grow-1"
      }, [_c(VAutocomplete, {
        staticClass: "required",
        attrs: {
          label: "Column ".concat(i + 1),
          disabled: _vm.isAnyActionInProgress,
          items: sheetToImport.columns,
          "item-text": "name",
          "item-value": "id",
          rules: [_vm.rules.mustSelectValue],
          "hide-details": "auto"
        },
        model: {
          value: sheetToImport.form.names[i].columnName,
          callback: function callback($$v) {
            _vm.$set(sheetToImport.form.names[i], "columnName", $$v);
          },
          expression: "sheetToImport.form.names[i].columnName"
        }
      })], 1), _c("div", {
        staticStyle: {
          width: "3rem",
          height: "2.8rem",
          top: "0.5rem"
        }
      }, [_c("div", {
        staticClass: "flex justify-center align-center gap-2",
        staticStyle: {
          height: "33%"
        }
      }, [i > 0 ? _c(VIcon, {
        staticClass: "fa fa-angle-up cursor--pointer mt-0",
        attrs: {
          disabled: _vm.isAnyActionInProgress,
          size: "0.75rem",
          title: "Move up"
        },
        on: {
          click: function click($event) {
            return _vm.positionFieldNameUp(sheetToImport, i);
          }
        }
      }) : _vm._e(), i > 0 ? _c(VIcon, {
        staticClass: "fa fa-angle-double-up cursor--pointer mt-0",
        attrs: {
          disabled: _vm.isAnyActionInProgress,
          size: "0.75rem",
          title: "Move to top"
        },
        on: {
          click: function click($event) {
            return _vm.positionFieldNameToFullTop(sheetToImport, i);
          }
        }
      }) : _vm._e()], 1), _c("div", {
        staticClass: "flex justify-center align-center",
        staticStyle: {
          height: "33%"
        }
      }, [_c(VIcon, {
        staticClass: "fa fa-trash cursor--pointer mt-0",
        attrs: {
          disabled: _vm.isAnyActionInProgress,
          size: "0.75rem"
        },
        on: {
          click: function click($event) {
            return _vm.removeFieldName(sheetToImport, i);
          }
        }
      })], 1), _c("div", {
        staticClass: "flex justify-center align-center gap-2",
        staticStyle: {
          height: "33%"
        },
        attrs: {
          title: "Remove"
        }
      }, [i < sheetToImport.form.names.length - 1 ? _c(VIcon, {
        staticClass: "fa fa-angle-down cursor--pointer mt-0",
        attrs: {
          disabled: _vm.isAnyActionInProgress,
          size: "0.75rem",
          title: "Move down"
        },
        on: {
          click: function click($event) {
            return _vm.positionFieldNameDown(sheetToImport, i);
          }
        }
      }) : _vm._e(), i < sheetToImport.form.names.length - 1 ? _c(VIcon, {
        staticClass: "fa fa-angle-double-down cursor--pointer mt-0",
        attrs: {
          disabled: _vm.isAnyActionInProgress,
          size: "0.75rem",
          title: "Move to bottom"
        },
        on: {
          click: function click($event) {
            return _vm.positionFieldNameToFullBottom(sheetToImport, i);
          }
        }
      }) : _vm._e()], 1)])]);
    }), 0), _c("div", {
      staticClass: "action-searchable-icon"
    }, [!_vm.isAnyActionInProgress ? _c(VIcon, {
      staticClass: "fa fa-plus icon-link",
      attrs: {
        small: "",
        round: "",
        title: "Add new column for the composition"
      },
      on: {
        click: function click($event) {
          return _vm.additionnalFieldName(sheetToImport);
        }
      }
    }) : _vm._e(), sheetToImport.form.names.length > 1 && !_vm.isAnyActionInProgress ? _c(VIcon, {
      staticClass: "fa fa-minus icon-link ml-2",
      attrs: {
        small: "",
        title: "Remove last column of the composition"
      },
      on: {
        click: function click($event) {
          return _vm.removeLastFieldName(sheetToImport);
        }
      }
    }) : _vm._e()], 1)]), _c("div", [_c("div", [_c("div", {
      staticClass: "subtitle"
    }, [_vm._v(" Excluded columns to automatically match product ")]), _c("div", {
      staticClass: "flex flex-column gap-4"
    }, _vm._l(sheetToImport.form.productlinkExcludedColumns, function (n, i) {
      return _c("div", {
        key: "productLinkReplacement" + i,
        staticClass: "flex w100p"
      }, [_c("div", {
        staticClass: "flex-grow-1"
      }, [_c(VAutocomplete, {
        staticClass: "required",
        attrs: {
          label: "Column ".concat(i + 1),
          disabled: _vm.isAnyActionInProgress,
          items: sheetToImport.columns,
          "item-text": "name",
          "item-value": "id",
          rules: [_vm.rules.mustSelectValue],
          "hide-details": "auto"
        },
        model: {
          value: sheetToImport.form.productlinkExcludedColumns[i].columnName,
          callback: function callback($$v) {
            _vm.$set(sheetToImport.form.productlinkExcludedColumns[i], "columnName", $$v);
          },
          expression: "\n                                  sheetToImport.form.productlinkExcludedColumns[i].columnName\n                                "
        }
      })], 1), _c("div", {
        staticStyle: {
          width: "3rem",
          height: "2.8rem",
          top: "0.5rem"
        }
      }, [_c("div", {
        staticClass: "flex justify-center align-center gap-2",
        staticStyle: {
          height: "33%"
        }
      }, [i > 0 ? _c(VIcon, {
        staticClass: "fa fa-angle-up cursor--pointer mt-0",
        attrs: {
          disabled: _vm.isAnyActionInProgress,
          size: "0.75rem",
          title: "Move up"
        },
        on: {
          click: function click($event) {
            return _vm.positionExcludedColumnUp(sheetToImport, i);
          }
        }
      }) : _vm._e(), i > 0 ? _c(VIcon, {
        staticClass: "fa fa-angle-double-up cursor--pointer mt-0",
        attrs: {
          disabled: _vm.isAnyActionInProgress,
          size: "0.75rem",
          title: "Move to top"
        },
        on: {
          click: function click($event) {
            return _vm.positionExcludedColumnToFullTop(sheetToImport, i);
          }
        }
      }) : _vm._e()], 1), _c("div", {
        staticClass: "flex justify-center align-center",
        staticStyle: {
          height: "33%"
        }
      }, [_c(VIcon, {
        staticClass: "fa fa-trash cursor--pointer mt-0",
        attrs: {
          disabled: _vm.isAnyActionInProgress,
          size: "0.75rem"
        },
        on: {
          click: function click($event) {
            return _vm.removeExcludedColumn(sheetToImport, i);
          }
        }
      })], 1), _c("div", {
        staticClass: "flex justify-center align-center gap-2",
        staticStyle: {
          height: "33%"
        },
        attrs: {
          title: "Remove"
        }
      }, [i < sheetToImport.form.productlinkExcludedColumns.length - 1 ? _c(VIcon, {
        staticClass: "fa fa-angle-down cursor--pointer mt-0",
        attrs: {
          disabled: _vm.isAnyActionInProgress,
          size: "0.75rem",
          title: "Move down"
        },
        on: {
          click: function click($event) {
            return _vm.positionExcludedColumnDown(sheetToImport, i);
          }
        }
      }) : _vm._e(), i < sheetToImport.form.productlinkExcludedColumns.length - 1 ? _c(VIcon, {
        staticClass: "fa fa-angle-double-down cursor--pointer mt-0",
        attrs: {
          disabled: _vm.isAnyActionInProgress,
          size: "0.75rem",
          title: "Move to bottom"
        },
        on: {
          click: function click($event) {
            return _vm.positionExcludedColumnToFullBottom(sheetToImport, i);
          }
        }
      }) : _vm._e()], 1)])]);
    }), 0), _c("div", {
      staticClass: "action-searchable-icon"
    }, [!_vm.isAnyActionInProgress ? _c(VIcon, {
      staticClass: "fa fa-plus icon-link",
      attrs: {
        small: "",
        round: "",
        title: "Add new column for the composition"
      },
      on: {
        click: function click($event) {
          return _vm.addExcludedColumn(sheetToImport);
        }
      }
    }) : _vm._e(), sheetToImport.form.names.length > 1 && !_vm.isAnyActionInProgress ? _c(VIcon, {
      staticClass: "fa fa-minus icon-link ml-2",
      attrs: {
        small: "",
        title: "Remove last column of the composition"
      },
      on: {
        click: function click($event) {
          return _vm.removeLastExcludedColumn(sheetToImport);
        }
      }
    }) : _vm._e()], 1)]), _c("div", {
      staticClass: "mt-3"
    }, [_c("div", {
      staticClass: "subtitle"
    }, [_vm._v(" Text adjustments to automatically match product ")]), _c("div", {
      staticClass: "flex flex-column gap-4"
    }, _vm._l(sheetToImport.form.productlinkReplacements, function (n, i) {
      return _c("div", {
        key: "productLinkReplacement" + i,
        staticClass: "flex w100p"
      }, [_c("div", {
        staticClass: "flex-grow-1"
      }, [_c(VTextField, {
        staticClass: "required",
        attrs: {
          disabled: _vm.isAnyActionInProgress,
          rules: [_vm.rules.mustNotBeEmpty],
          label: "Text to be replaced, accents handled with the simple letter",
          "hide-details": "auto"
        },
        model: {
          value: sheetToImport.form.productlinkReplacements[i].toReplace,
          callback: function callback($$v) {
            _vm.$set(sheetToImport.form.productlinkReplacements[i], "toReplace", $$v);
          },
          expression: "sheetToImport.form.productlinkReplacements[i].toReplace"
        }
      }), _c(VTextField, {
        staticClass: "v-text-field-no-label",
        attrs: {
          disabled: _vm.isAnyActionInProgress,
          prefix: "by:",
          placeholder: "Text for replacement",
          "hide-details": "auto"
        },
        model: {
          value: sheetToImport.form.productlinkReplacements[i].replaceBy,
          callback: function callback($$v) {
            _vm.$set(sheetToImport.form.productlinkReplacements[i], "replaceBy", $$v);
          },
          expression: "sheetToImport.form.productlinkReplacements[i].replaceBy"
        }
      })], 1), _c("div", {
        staticStyle: {
          width: "3rem",
          height: "2.8rem",
          top: "1rem"
        }
      }, [_c("div", {
        staticClass: "flex justify-center align-center gap-2",
        staticStyle: {
          height: "33%"
        }
      }, [i > 0 ? _c(VIcon, {
        staticClass: "fa fa-angle-up cursor--pointer mt-0",
        attrs: {
          disabled: _vm.isAnyActionInProgress,
          size: "0.75rem",
          title: "Move up"
        },
        on: {
          click: function click($event) {
            return _vm.positionReplacementUp(sheetToImport, i);
          }
        }
      }) : _vm._e(), i > 0 ? _c(VIcon, {
        staticClass: "fa fa-angle-double-up cursor--pointer mt-0",
        attrs: {
          disabled: _vm.isAnyActionInProgress,
          size: "0.75rem",
          title: "Move to top"
        },
        on: {
          click: function click($event) {
            return _vm.positionReplacementToFullTop(sheetToImport, i);
          }
        }
      }) : _vm._e()], 1), _c("div", {
        staticClass: "flex justify-center align-center",
        staticStyle: {
          height: "33%"
        }
      }, [_c(VIcon, {
        staticClass: "fa fa-trash cursor--pointer mt-0",
        attrs: {
          disabled: _vm.isAnyActionInProgress,
          size: "0.75rem"
        },
        on: {
          click: function click($event) {
            return _vm.removeReplacement(sheetToImport, i);
          }
        }
      })], 1), _c("div", {
        staticClass: "flex justify-center align-center gap-2",
        staticStyle: {
          height: "33%"
        },
        attrs: {
          title: "Remove"
        }
      }, [i < sheetToImport.form.productlinkReplacements.length - 1 ? _c(VIcon, {
        staticClass: "fa fa-angle-down cursor--pointer mt-0",
        attrs: {
          disabled: _vm.isAnyActionInProgress,
          size: "0.75rem",
          title: "Move down"
        },
        on: {
          click: function click($event) {
            return _vm.positionReplacementDown(sheetToImport, i);
          }
        }
      }) : _vm._e(), i < sheetToImport.form.productlinkReplacements.length - 1 ? _c(VIcon, {
        staticClass: "fa fa-angle-double-down cursor--pointer mt-0",
        attrs: {
          disabled: _vm.isAnyActionInProgress,
          size: "0.75rem",
          title: "Move to bottom"
        },
        on: {
          click: function click($event) {
            return _vm.positionReplacementToFullBottom(sheetToImport, i);
          }
        }
      }) : _vm._e()], 1)])]);
    }), 0), _c("div", {
      staticClass: "action-searchable-icon"
    }, [!_vm.isAnyActionInProgress ? _c(VIcon, {
      staticClass: "fa fa-plus icon-link",
      attrs: {
        small: "",
        round: "",
        title: "Add new column for the composition"
      },
      on: {
        click: function click($event) {
          return _vm.addReplacement(sheetToImport);
        }
      }
    }) : _vm._e(), sheetToImport.form.names.length > 1 && !_vm.isAnyActionInProgress ? _c(VIcon, {
      staticClass: "fa fa-minus icon-link ml-2",
      attrs: {
        small: "",
        title: "Remove last column of the composition"
      },
      on: {
        click: function click($event) {
          return _vm.removeLastReplacement(sheetToImport);
        }
      }
    }) : _vm._e()], 1)])])])]) : _vm._e()], 1) : _vm._e()], 1);
  }), 0) : _vm._e()], 2)] : [_vm.items.length > 0 ? _c("div", [_c("section", [_c("div", {
    staticClass: "result-content"
  }, [_c("div", [_c("i", {
    staticClass: "fas fa-lightbulb pr-2"
  }), _vm._v(" Below, you can find a sum up of the import. ")]), _c("div", {
    staticClass: "result-content-item ml-1"
  }, [_c("div", [_vm._v("Legend :")]), _c("div", [_c("svg", {
    staticClass: "icon icon-xxs dot",
    class: ["fill-danger"],
    attrs: {
      xmlns: "http://www.w3.org/2000/svg",
      width: "512",
      height: "512",
      viewBox: "0 0 512 512"
    }
  }, [_c("circle", {
    attrs: {
      cx: "256",
      cy: "256",
      r: "256"
    }
  })]), _vm._v(" " + _vm._s(_vm.result.danger) + " not imported ")]), _c("div", [_c("svg", {
    staticClass: "icon icon-xxs dot",
    class: ["fill-warning"],
    attrs: {
      xmlns: "http://www.w3.org/2000/svg",
      width: "512",
      height: "512",
      viewBox: "0 0 512 512"
    }
  }, [_c("circle", {
    attrs: {
      cx: "256",
      cy: "256",
      r: "256"
    }
  })]), _vm._v(" " + _vm._s(_vm.result.warning) + " imported & not linked to wine ")]), _c("div", [_c("svg", {
    staticClass: "icon icon-xxs dot",
    class: ["fill-success"],
    attrs: {
      xmlns: "http://www.w3.org/2000/svg",
      width: "512",
      height: "512",
      viewBox: "0 0 512 512"
    }
  }, [_c("circle", {
    attrs: {
      cx: "256",
      cy: "256",
      r: "256"
    }
  })]), _vm._v(" " + _vm._s(_vm.result.success) + " imported & linked to wine ")])])])])]) : _vm._e(), _c("ImportSupplierPricesHeader", {
    attrs: {
      status: _vm.formFilters.status.selected,
      statusOptions: _vm.formFilters.status.options
    },
    on: {
      "update:status": function updateStatus(val) {
        return _vm.formFilters.status.selected = val;
      },
      "export-errors": _vm.exportErrors
    }
  }), _c(VDataTable, {
    staticClass: "elevation-2",
    attrs: {
      id: "table",
      headers: _vm.headers,
      items: _vm.filteredRows,
      "sort-by": ["status"],
      "sort-desc": [true],
      "loading-text": "Loading... Please wait"
    },
    scopedSlots: _vm._u([{
      key: "item.status",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c("svg", {
          staticClass: "icon icon-xxs dot",
          class: ["fill-".concat(item.statusLabel)],
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: "512",
            height: "512",
            viewBox: "0 0 512 512"
          }
        }, [_c("circle", {
          attrs: {
            cx: "256",
            cy: "256",
            r: "256"
          }
        })])];
      }
    }, {
      key: "item.description",
      fn: function fn(_ref2) {
        var _item$nameForProductL;
        var item = _ref2.item;
        return [_c("div", [_vm._v(" " + _vm._s(item.description) + " "), item.wineId ? [_c("router-link", {
          staticClass: "router-link ml-2",
          attrs: {
            to: _vm.toProductDetails(item),
            target: "_blank"
          }
        }, [_c("i", {
          staticClass: "fas fa-external-link-alt"
        })])] : _vm._e()], 2), !item.wineId && ((_item$nameForProductL = item.nameForProductLink) === null || _item$nameForProductL === void 0 ? void 0 : _item$nameForProductL.length) > 0 ? _c("div", {
          staticClass: "text-smaller"
        }, [_vm._v(" Failed link : " + _vm._s(item.nameForProductLink) + " ")]) : _vm._e()];
      }
    }, {
      key: "item.supplierCogs",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s("".concat(item.supplierCogs, " \u20AC")) + " ")];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c("div", {
          staticClass: "my-2 flex gap-2"
        }, [item.wineId == null ? _c(VBtn, {
          staticClass: "dfwa-btn --small-2 highlight",
          attrs: {
            rounded: ""
          },
          on: {
            click: function click($event) {
              return _vm.openAssociateWineModal(item);
            }
          }
        }, [_c(VIcon, {
          staticClass: "fa fa-link mr-1",
          attrs: {
            size: "0.65rem"
          }
        }), _vm._v(" Attach to existing wine ")], 1) : _vm._e(), item.wineId == null ? _c(VBtn, {
          staticClass: "dfwa-btn --small-2 secondary",
          attrs: {
            rounded: ""
          },
          on: {
            click: function click($event) {
              return _vm.openCreateWineDialog(item);
            }
          }
        }, [_c(VIcon, {
          staticClass: "fa fa-plus mr-1",
          attrs: {
            size: "0.65rem"
          }
        }), _vm._v(" Create Wine ")], 1) : _vm._e(), item.statusLabel == "success" ? _c("span", [_vm._v("-")]) : _vm._e()], 1)];
      }
    }], null, true)
  })]], 2), _vm.isConfiguring && _vm.isImporting ? _c("div", {
    staticClass: "text-bottom"
  }, [_c("section", [_vm._v("It may take a while. Please wait a moment.")])]) : _vm._e(), _c(VCardActions, {
    staticClass: "actions-bottom-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.cancel();
      }
    }
  }, [_vm._v(" " + _vm._s(!_vm.items.length && _vm.isConfiguring ? "Cancel" : "Close") + " ")]), !_vm.items.length && _vm.isConfiguring && ((_vm$sheetsToImport = _vm.sheetsToImport) === null || _vm$sheetsToImport === void 0 ? void 0 : _vm$sheetsToImport.length) > 0 ? _c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: "",
      loading: _vm.isSavingSettings,
      disabled: _vm.isSyncingFile || _vm.isImporting
    },
    on: {
      click: function click($event) {
        return _vm.saveSupplierSettings();
      }
    }
  }, [_vm._v(" Save Settings ")]) : _vm._e(), !_vm.items.length && _vm.isConfiguring ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      loading: _vm.isImporting,
      rounded: "",
      disabled: _vm.isSyncingFile || _vm.isSavingSettings || !_vm.supplierId || !_vm.canBeSubmitted
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v(" Import prices ")]) : _vm._e(), !_vm.isConfiguring ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.restart();
      }
    }
  }, [_vm._v(" Restart import "), _c("i", {
    staticClass: "fas fa-reply-all pl-1"
  })]) : _vm._e()], 1)], 1), _vm.createWineModal.isVisible ? _c("NewWineDialog", {
    attrs: {
      shown: _vm.createWineModal.isVisible,
      loggedUserData: _vm.loggedUserData,
      supplierPrice: _vm.createWineModal.selectedSupplierPrice
    },
    on: {
      close: _vm.closeCreateWineDialog,
      savedForSupplier: _vm.createWineSavedDialog
    }
  }) : _vm._e(), _vm.items.length > 0 ? _c("AssociateWineModal", {
    ref: "associateWineModal",
    attrs: {
      wineFiltersStorageKey: "supplierPriceAssociateWines",
      loggedUserData: _vm.loggedUserData,
      modal: {
        title: "Associate wine - ".concat(_vm.associateWine.selectedSupplierPrice.description)
      },
      wine: {
        wineSupplierPrice: _vm.associateWine.selectedSupplierPrice
      },
      filtersVisibility: {
        showStockOnly: false,
        showWarehouseOnly: false,
        showSpecialDealsOnly: false,
        showDepartureContinent: false,
        showStockQuantityMin: false
      },
      wineCard: {
        displaySkuInsteadOfPrice: true
      },
      thirdPartyUserSelector: {
        display: false
      }
    },
    on: {
      associateWine: _vm.associateWineToSupplierPrice
    }
  }) : _vm._e(), _c("Confirm", {
    ref: "confirm"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };